import folderApi from "@/api/modules/basicData/folder";
import capi from "@/api/modules/basicData/cluster";
import {
  getToken
} from '../../util/auth'
import Linq from 'linq';
import folder from "../../api/modules/basicData/folder";
import {
  Message
} from 'element-ui';
const currentUser = getToken()
export default ({
  state: {
    onlyGroup: true, //返回的数据是否是团队数据还是所有数据 true 团队时间 false：所有数据
    teamExpandedKeys: ['-2'], //展开的节点数组
    expandedKeys: ['-2'], //展开的节点数组事件中需要
    mindTreeDta: {}, //团队树结构
    teamTreeData: [], //团队树结构
    teamTreeList: [], //团队所有数据
    copyList: [], //复制的值
    selectionList: [], //选中值
    pNodeId: '',
    listGroup: null,
    parentInfo: {}, //父节点相关信息
    taskGroupNative: [],
    taskGroupCurrent: [],
    taskGroupList: [],
    taskGroupTree: [],
    startShiftInfo: null, //shift需要的值，用于shift多选功能
    taskGropuParent: [], //所有父级
    selectFolderType: 0, //文件显示方式 0 列表  1 卡片
    isFolderView: false, //是否显示文件视图方式
    pathNameArr: [], //面包屑
    BreadcrumbData: [], //新面包屑
    OrderIndex: 0, //排序 0：时间 1：名称 2：类型 3：状态 4：人员
    OrderBy: 'desc', //asc：升序 desc：降序
    ViewType: 1, //0:卡片 1:详细视图
    isCopyOrPaste: 0, //0:复制 1:剪切
    folderState: 1, //0:常用 1：文件夹
    permissionType: 2, //0:个人 1：共享 2：群聊
    pathName: '',
    isPasteDisabled: false, //粘贴状态
    Person: {
      ID: currentUser.userId,
      NAME: currentUser.realName,
      DEPTID: currentUser.departmentId,
      DEPTNAME: currentUser.departmentName,
      COMPANYID: currentUser.companyId,
      COMPANYNAME: currentUser.companyName
    },
    nodeState: [{
        name: '任务',
        value: '0',
      },
      {
        name: '项目',
        value: '1',
      },
      {
        name: '计划',
        value: '2',
      },
      {
        name: '任务组',
        value: '3',
      },
      {
        name: '快捷方式',
        value: '4',
      },
    ],
    groupId: '', //群组Id
    IsRoot: true, //是否根目录,
    isGroupList: false, //是否团队列表
    isSearch: false, //是否文件夹查询
  },
  mutations: {
    setOnlyGroup(state, onlyGroup) {
      state.onlyGroup = onlyGroup
    },
    setTeamExpandedKeys(state, teamExpandedKeys) {
      state.teamExpandedKeys = teamExpandedKeys;
    },
    setExpandedKeys(state, expandedKeys) {
      state.expandedKeys = expandedKeys;
    },
    setIsSearch(state, isSearch) {
      state.isSearch = isSearch;
    },
    setGroupId(state, groupId) {
      state.groupId = groupId;
    },
    setSelectionList(state, list) {
      state.selectionList = list;
    },
    setPermissionType(state, permissionType) {
      state.permissionType = permissionType;
    },
    setFolderPath(state, item) {
      if (item) {
        if (item.state == 0) {

        } else {
          // let row = {
          //   ...item
          // };
          // row.NAMEPATH = row.NODEID ? (row.NAMEPATH ? row.NAMEPATH + '\\' + row.NODENAME : row.NODENAME) : "";
          // row.IDPATH = row.NODEID ? (row.IDPATH ? row.IDPATH + '\\' + row.NODEID : row.NODEID) : "";
          // state.pathName = row.NAMEPATH;
          // console.log('NAMEPATH', row.NAMEPATH);
          // console.log('IDPATH', row.IDPATH);
          // let pathName = state.pathName ? state.pathName.split('\\') : [];
          // let pathIds = row.IDPATH ? row.IDPATH.toString().split('\\') : [];
          // let arr = [];
          // let i = 0;
          // pathName.forEach(p => {
          //   let v = ''
          //   let ids = ''
          //   for (let index = 0; index <= i; index++) {
          //     v += pathName[index] + '\\';
          //   }
          //   for (let index = 0; index <= i; index++) {
          //     ids += pathIds[index] + '\\';
          //   }
          //   arr.push({
          //     lable: p,
          //     value: v.substring(0, v.length - 1),
          //     pid: ids.substring(0, ids.length - 1)
          //   });
          //   i++
          // });

          // state.pathNameArr = arr
          // console.log('setPathName1', arr);
          // console.log('pNodeId值：', row.NODEID);
          // state.pNodeId = row.NODEID;
          // state.parentInfo = row;
          // console.log('state.parentInfo',state.parentInfo);
          // this.commit('setIsPasteDisabled');
          length = state.pathNameArr.length;
          console.log('pathNameArr',state.pathNameArr)
          if(length>0){

    
            // let info = state.pathNameArr[state.pathNameArr.length-1]
            
            let index = state.pathNameArr.findIndex(p => p.NODEID == item.NODEID);
            console.log('index',index)
            // if(info.NODEID!=item.PNODEID){
            //   let pathNameArr = state.pathNameArr;
            //   let newarr=pathNameArr.slice(0);
            //   newarr.pop();
            //   state.pathNameArr = newarr;
            // }
            // else 
            if (index == -1) {
              let pathNameArr = state.pathNameArr;
              pathNameArr.push(item);
              state.pathNameArr = pathNameArr;
            } else {
              state.pathNameArr = state.pathNameArr.slice(0, index + 1)
            }
          }else{
            let pathNameArr = state.pathNameArr;
            pathNameArr.push(item);
            state.pathNameArr = pathNameArr;
          }
          console.log('pathNameArr', state.pathNameArr);
          state.pNodeId = item.NODEID;
          this.commit('setIsPasteDisabled');

        }
        state.parentInfo = item;
        console.log('state.parentInfo', item);
      } else {
        state.pathNameArr = [];
        state.pNodeId = "";
        state.parentInfo = {
          NODEID: "",
          NODENAME: "",
          PARENTID: "-1"
        };
        this.commit('setIsPasteDisabled');
      }
    },
    setTreeFolderPath(state, data) {
      state.pathNameArr = data;
    },
    setParentInfo(state, item) {
      state.parentInfo = item;
      state.pNodeId = item.NODEID;
      this.commit('setIsPasteDisabled');
    },
    setBreadcrumbData(state, res) {
      // state.pathNameArr = res[0].NAMEPATH ? res[0].NAMEPATH.split(',') : [];
      // state.pathName = res[0].NAMEPATH;
      // state.pNodeId = paras.NodeId;
      // state.parentInfo = res[0];
      if (res && res.length > 0) {
        // state.pathName = '';
        // state.pathNameArr = [];
        // state.pNodeId = '';
        // state.parentInfo = item;
      } else {
        let row = res[0];
        row.NAMEPATH = row.NODEID ? (row.NAMEPATH ? row.NAMEPATH + '\\' + row.NODENAME : row.NODENAME) : "";
        row.IDPATH = row.NODEID ? (row.IDPATH ? row.IDPATH + '\\' + row.NODEID : row.NODEID) : "";
        state.pathName = row.NAMEPATH;
        console.log('NAMEPATH', row.NAMEPATH);
        console.log('IDPATH', row.IDPATH);
        let pathName = state.pathName ? state.pathName.split('\\') : [];
        let pathIds = row.IDPATH ? row.IDPATH.toString().split('\\') : [];
        let arr = [];
        let i = 0;
        pathName.forEach(p => {
          let v = ''
          let ids = ''
          for (let index = 0; index <= i; index++) {
            v += pathName[index] + '\\';
          }
          for (let index = 0; index <= i; index++) {
            ids += pathIds[index] + '\\';
          }
          arr.push({
            lable: p,
            value: v.substring(0, v.length - 1),
            pid: ids.substring(0, ids.length - 1)
          });
          i++
        });

        state.pathNameArr = arr
        console.log('setPathName1', arr);
        console.log('pNodeId值：', row.NODEID);
        state.pNodeId = row.NODEID;
        state.parentInfo = row;
        this.commit('setIsPasteDisabled');
      }
    },
    setPathName(state, index) {
      let arr = [];
      let i = 0;
      state.pathNameArr.forEach(item => {
        if (index > i) {
          arr.push({
            lable: item.lable,
            value: item.value,
            pid: item.pid ? item.pid : '',
          });
        }
        i++;
      });
      console.log('setPathName2', arr);
      let NODENAME = ''
      let IDPATH = ''
      let NAMEPATH = ''
      if (arr.length == 0) {
        state.pNodeId = '';
      } else {
        let pids = arr[arr.length - 1].pid.split('\\');
        let nids = arr[arr.length - 1].lable.split('\\');
        state.pNodeId = pids[pids.length - 1]
        NODENAME = nids[nids.length - 1]
        IDPATH = arr[arr.length - 1].value;
        NAMEPATH = arr[arr.length - 1].lable;
      }
      console.log('pNodeId2', state.pNodeId);
      state.pathNameArr = arr;
      state.parentInfo = {
        NODEID: state.pNodeId,
        NODENAME: NODENAME,
        IDPATH: IDPATH,
        NAMEPATH: NAMEPATH
      };
      state.pathName = NODENAME
      this.commit('setIsPasteDisabled');
    },
    setIsPasteDisabled(state) {
      if (state.copyList.length > 0) {
        let PNODEID1 = state.copyList[0].PNODEID;
        let PNODEID2 = state.pNodeId;

        let NODEID = state.copyList[0].NODEID.toString();
        console.log('PNODEID1', PNODEID1);
        console.log('PNODEID2', PNODEID2)
        if (!PNODEID1) {
          PNODEID1 = '';
        }
        if (!PNODEID2) {
          PNODEID2 = '';
        }
        let IDPATH = state.parentInfo.IDPATH ? state.parentInfo.IDPATH.toString().split('\\') : [];
        console.log('IDPATH', IDPATH);
        console.log('NODEID', NODEID)
        console.log('NODEID1', IDPATH.indexOf(NODEID))
        if (PNODEID1 != PNODEID2 && IDPATH.indexOf(NODEID) < 0) {
          state.isPasteDisabled = true;
        } else {
          state.isPasteDisabled = false;
        }
      } else {
        state.isPasteDisabled = false;
      }
    },
    setFolderState(state, folderState) {
      state.folderState = folderState
    },
    setIsCopyOrPaste(state, isCopyOrPaste) {
      state.isCopyOrPaste = isCopyOrPaste
    },
    setCopy(state, item) {
      console.log('setCopy', item);
      state.copyList = item;
      this.commit('setIsPasteDisabled');
    },
    setSelectFolderType(state, type) {
      state.selectFolderType = type;
    },
    setIsFolderView(state, isTrue) {
      state.isFolderView = isTrue;
    },
    setOrderIndex(state, orderIndex) {
      console.log('setOrderIndex', orderIndex);
      state.OrderIndex = orderIndex;
      this.commit('getFolderload');
    },
    setOrderBy(state, orderBy) {
      console.log('setOrderBy', orderBy);
      state.OrderBy = orderBy;
      this.commit('getFolderload');
    },
    setViewType(state, viewType) {
      console.log(viewType);
      state.ViewType = viewType;
      this.commit('getFolderload');
    },
    setStartShiftInfo(state, startShiftInfo) {
      state.startShiftInfo = startShiftInfo;
    },
    setEditTaskGroupList(state, index) {
      state.taskGroupList.forEach(item => {
        if (item.index == index) {
          item.isEdit = true
        } else {
          item.isEdit = false
        }
      });
    },
    getFolderload(state) {
      if (state.taskGroupList.length > 0) {
        switch (state.OrderIndex) {
          case 0: //时间
            if (state.OrderBy == 'desc') {
              state.taskGroupList = Linq.from(state.taskGroupList).orderByDescending(item => item.CREATETIME).toArray();
            } else {
              state.taskGroupList = Linq.from(state.taskGroupList).orderBy(item => item.CREATETIME).toArray();
            }
            break;
          case 1:
            if (state.OrderBy == 'desc') {
              state.taskGroupList = Linq.from(state.taskGroupList).orderByDescending(item => item.NODENAME).toArray();
            } else {
              state.taskGroupList = Linq.from(state.taskGroupList).orderBy(item => item.NODENAME).toArray();
            }
            break;
          case 2:
            if (state.OrderBy == 'desc') {
              state.taskGroupList = Linq.from(state.taskGroupList).orderByDescending(item => item.RELATIONTYPE).toArray();
            } else {
              state.taskGroupList = Linq.from(state.taskGroupList).orderBy(item => item.RELATIONTYPE).toArray();
            }
            break;
          case 3:
            if (state.OrderBy == 'desc') {
              state.taskGroupList = Linq.from(state.taskGroupList).orderByDescending(item => item.RELATIONSTATE).toArray();
            } else {
              state.taskGroupList = Linq.from(state.taskGroupList).orderBy(item => item.RELATIONSTATE).toArray();
            }
            break;
          case 4:
            if (state.OrderBy == 'desc') {
              state.taskGroupList = Linq.from(state.taskGroupList).orderByDescending(item => item.CREATEUSERNAME).toArray();
            } else {
              state.taskGroupList = Linq.from(state.taskGroupList).orderBy(item => item.CREATEUSERNAME).toArray();
            }
            break;
          default:
            state.taskGroupList = Linq.from(state.taskGroupList).orderByDescending(item => item.CREATETIME).toArray();
            break;
        }
      }
      let index = 0;
      state.taskGroupList.forEach(item => {
        item.isEdit = false;
        item.index = index;
        index++;
      });
    },
  },
  actions: {
    GetMyChatGroup({
      state,
      dispatch,
      commit
    }, paras) {
      // paras.Person = state.Person;
      folderApi.GetMyChatGroup(state.Person).then(res => {
        state.taskGroupList = res;
        if (res && res.length > 0) {
          commit('getFolderload')
          if (res[0].NAMEPATH) {
            // dispatch('GetCurPathParentTree', res[0].NAMEPATH);
          } else {
            res.forEach(item => {
              item.isLeaf = item.CHILDRENCOUNT == 0;
            });
            let treeList = res.filter(item => item.NODETYPE == 3);
            console.log('treeList', treeList);
            state.taskGroupTree = treeList;
          }
        }
      })
    },
    GetGroupList({
      state,
      dispatch,
      commit
    }, paras) {
      paras.Person = state.Person;
      if (paras.IsRoot) {
        paras.PermissionType = state.permissionType;
        state.IsRoot = true;
      } else {
        state.IsRoot = false;
      }
      if (state.permissionType === 2 && state.IsRoot) {
        state.isGroupList = true; //判断是否是团队跟目录
      } else {
        state.isGroupList = false;
      }

      if (paras.NodeName) {
        commit('setIsSearch', true);
      } else {
        commit('setIsSearch', false);
      }
      folderApi.GetTaskTreePathList(paras).then(res => {
        state.listGroup = res
      })
    },
    GetTaskTreePathList({
      state,
      dispatch,
      commit
    }, paras) {
      paras.Person = state.Person;
      if (paras.IsRoot) {
        paras.PermissionType = state.permissionType;
        state.IsRoot = true;
      } else {
        state.IsRoot = false;
      }
      if (state.permissionType === 2 && state.IsRoot) {
        state.isGroupList = true; //判断是否是团队跟目录
      } else {
        state.isGroupList = false;
      }

      if (paras.NodeName) {
        commit('setIsSearch', true);
      } else {
        commit('setIsSearch', false);
      }

      folderApi.GetTaskTreePathList(paras).then(res => {
        state.taskGroupList = res;
        // if(paras.row){
        //   commit('setFolderPath',paras.row)
        // }
        if (res && res.length > 0) {
          commit('getFolderload')
          if (paras.NodeName || (paras.Path && !state.IsRoot)) {
            if (res.length === 1) {
              commit('setFolderPath', res[0])
            }
          }
          // state.pathNameArr = res[0].NAMEPATH ? res[0].NAMEPATH.split(',') : [];
          // state.pathName = res[0].NAMEPATH;
          // state.pNodeId = paras.NodeId;
          // state.parentInfo = res[0];


          if (res[0].NAMEPATH) {
            // dispatch('GetCurPathParentTree', res[0].NAMEPATH);
          } else {
            res.forEach(item => {
              item.isLeaf = item.CHILDRENCOUNT == 0;
            });
            let treeList = res.filter(item => item.NODETYPE == 3);
            console.log('treeList', treeList);
            state.taskGroupTree = treeList;
          }

          // const list = JSON.parse(JSON.stringify(res))
          // state.taskGroupList = listToTree('ID', 'PARENTID', list)
          // state.taskGroupNative = res.Items
          // state.taskGroupCurrent = res.Items.filter(p => !p.PARENTID)
        }
      })
    },
    GetTaskByChatGroupId({
      state,
      dispatch,
      commit
    }, groupId) {
      state.IsRoot = true;
      commit('setGroupId', groupId);
      folderApi.GetTaskByChatGroupId(groupId, currentUser.userId).then(res => {
        state.taskGroupList = res;
        if (res && res.length > 0) {
          commit('getFolderload')
          if (res[0].NAMEPATH) {
            // dispatch('GetCurPathParentTree', res[0].NAMEPATH);
          } else {
            res.forEach(item => {
              item.isLeaf = item.CHILDRENCOUNT == 0;
            });
            let treeList = res.filter(item => item.NODETYPE == 3);
            console.log('treeList', treeList);
            state.taskGroupTree = treeList;
          }
        }
        state.isGroupList = false;
      })
    },
    GetTaskTreePathGroup({
      state,
      dispatch,
      commit
    }, taskId) {
      state.isGroupList = false;
      commit('setIsSearch', false);
      folderApi.GetTaskTreePathGroup(taskId, currentUser.userId).then(res => {
        state.taskGroupList = res;
        if (res && res.length > 0) {
          commit('setFolderPath', res[0])
          commit('getFolderload')
          if (res[0].NAMEPATH) {
            // dispatch('GetCurPathParentTree', res[0].NAMEPATH);
          } else {
            res.forEach(item => {
              item.isLeaf = item.CHILDRENCOUNT == 0;
            });
            let treeList = res.filter(item => item.NODETYPE == 3);
            console.log('treeList', treeList);
            state.taskGroupTree = treeList;
          }
        }
      })
    },
    GetCurPathParentTree({
      state,
      dispatch,
      commit
    }, curPath) {
      folderApi.GetCurPathParentTree(curPath).then(res => {
        if (res && res.length > 0) {
          res.forEach(item => {
            item.isLeaf = item.CHILDRENCOUNT == 0;
          });
          let treeList = res.filter(item => {
            item.NODETYPE == 3
          });
          state.taskGroupTree = treeList;
        }
      })
    },
    loadTreePathList({
        state,
        dispatch,
        commit
      },
      paras) {
      let IsRoot = true;
      if (!state.parentInfo.PARENTID && state.parentInfo.PARENTID !== "-1") {
        IsRoot = false;
      }
      dispatch('GetTaskTreePathList', {
        NodeId: state.parentInfo.NODEID,
        IsRoot: IsRoot,
        PermissionType: state.permissionType
      })

    },
    SheartoPaste({ //剪切 粘贴
      state,
      dispatch,
      commit
    }, treePath) {
      if (state.pNodeId) {

      } else {
        treePath.PNODENAME = '';
        treePath.PNODETYPE = 0
      }

      treePath.PNODEID = state.pNodeId;
      dispatch('UpdateTaskTreePath', treePath)
    },
    AddTaskTreePath({
      state,
      dispatch,
      commit
    }, treePath) {
      folder.AddTaskTreePath(treePath).then(res => {
        if (res.ResultCode == 1) {
          // Message.success({
          //   message: "成功",
          //   center: true
          // })
          if (state.folderState == 0) {
            dispatch('loadFrequentTreePathList')
          } else if (state.permissionType == 2 && state.IsRoot) { //群聊
            dispatch('GetTaskByChatGroupId', state.groupId)
          } else {
            dispatch('loadTreePathList')
          }
          dispatch('GetMyTaskTreePath');
        } else {
          Message.error({
            message: "错误，请重试",
            center: true
          })
        }
      });
    },
    InsertTaskIntoFolder({
      state,
      dispatch,
      commit
    }, treePath) {
      folder.InsertTaskIntoFolder(treePath.folderList, treePath.folderId, 1).then(res => {
        if (res.ResultCode == 1) {
          // Message.success({
          //   message: "成功",
          //   center: true
          // })
          if (state.folderState == 0) {
            dispatch('loadFrequentTreePathList')
          } else if (state.permissionType == 2 && state.IsRoot) { //群聊
            dispatch('GetTaskByChatGroupId', state.groupId)
          } else {
            dispatch('loadTreePathList')
          }
          dispatch('GetMyTaskTreePath');
        } else {
          Message.error({
            message: "错误，请重试",
            center: true
          })
        }
      });
    },
    AddChatGroupTask({
      state,
      dispatch,
      commit
    }, model) {
      console.log('AddChatGroupTask', model);
      folder.AddChatGroupTask(model).then(res => {
        if (res.ResultCode == 1) {
          if (state.pathName) {
            dispatch("loadTreePathList");
          } else {
            dispatch("GetTaskByChatGroupId", model.GROUPID);
          }
          dispatch('GetMyTaskTreePath');
        } else {
          Message.error({
            message: "错误，请重试",
            center: true
          })
        }
      });
    },
    UpdateTaskTreePath({
      state,
      dispatch,
      commit
    }, treePath) {
      folder.UpdateTaskTreePath(treePath, state.Person).then(res => {
        if (res.ResultCode == 1) {
          // Message.success({
          //   message: "成功",
          //   center: true
          // })
          if (state.folderState == 0) {
            dispatch('loadFrequentTreePathList')
          } else {
            dispatch('loadTreePathList')
          }
          dispatch('GetMyTaskTreePath');
        } else {
          Message.error({
            message: "错误，请重试",
            center: true
          })
        }
      });
    },
    DelTaskTreePath({
      state,
      dispatch,
      commit
    }, treePath) {
      folder.DelTaskTreePath(treePath, state.Person).then(res => {
        if (res.ResultCode == 1) {
          // Message.success({
          //   message: "成功",
          //   center: true
          // })
          if (state.folderState == 0) {
            dispatch('loadFrequentTreePathList')
          } else if (state.permissionType == 2 && state.IsRoot) {
            dispatch('GetTaskByChatGroupId', state.groupId)
          } else {
            dispatch('loadTreePathList')
          }
          dispatch('GetMyTaskTreePath');
        } else {
          Message.error({
            message: "错误，请重试",
            center: true
          })
        }
      });
    },
    GetFrequentTreePath({
      state,
      dispatch,
      commit
    }) {
      commit('setIsSearch', false);
      folderApi.GetFrequentTreePath(state.Person).then(res => {
        state.taskGroupList = res;
        if (res && res.length > 0) {
          commit('getFolderload')
        }
      })
    },
    loadFrequentTreePathList({
      state,
      dispatch,
      commit
    }) {
      dispatch('GetFrequentTreePath')

    },
    AddFrequentTreePath({
      state,
      dispatch,
      commit
    }, treePath) {
      treePath.CREATEUSERID = currentUser.userId
      treePath.CREATEUSERNAME = currentUser.realName
      treePath.CREATEDEPTID = currentUser.departmentId
      treePath.CREATEDEPTNAME = currentUser.departmentName
      treePath.CREATECOMPANYID = currentUser.companyId
      treePath.CREATECOMPANYNAME = currentUser.companyName
      folder.AddFrequentTreePath(treePath).then(res => {
        if (res.ResultCode == 1) {
          dispatch('GetMyTaskTreePath');
          if (state.folderState == 0) {
            dispatch('loadFrequentTreePathList')
          } else {
            dispatch('loadTreePathList')
          }
        } else if (res.ResultCode == -1) {
          Message.info({
            message: res.MsgInfo,
            center: true
          })
        } else {
          Message.error({
            message: "错误，请重试",
            center: true
          })
        }
      });
    },
    DelFrequentTreePath({
      state,
      dispatch,
      commit
    }, treePath) {
      let nodeids = treePath.map(function(item) {
        return item.NODEID;
      })
      folder.DelFrequentTreePath(nodeids, state.Person).then(res => {
        if (res.ResultCode == 1) {
          dispatch('GetMyTaskTreePath');
          if (state.folderState == 0) {
            dispatch('loadFrequentTreePathList')
          } else {
            dispatch('loadTreePathList')
          }
        } else {
          Message.error({
            message: "错误，请重试",
            center: true
          })
        }
      });
    },
    removeCluster({
      state,
      dispatch
    }, groupId) { // 删除团队
      capi.removerCluster(groupId).then((res) => {
        Message.success({
          message: "团队删除成功",
          center: true
        });
        state.pathNameArr=[];
        dispatch('GetMyTaskTreePath');
        // dispatch('loadTreePathList')
        dispatch('GetTaskTreePathList', {
          NodeId: '',
          IsRoot: true,
          PermissionType: state.permissionType
        })
      })
    },
    GetMyTaskTreePath({
      state,
      dispatch
    }) { // 团队
      folderApi.GetMyTaskTreePath(state.Person, state.onlyGroup).then(res => {
        let item = [];
        if (res) {
          item = res.find(p => p.NODENAME == '团队');
        }
        state.teamExpandedKeys = state.expandedKeys;
        state.teamTreeList = item.children;
        state.mindTreeDta = item;
        state.teamTreeData = item.children
        // state.teamTreeData=[{
        //     NODENAME: "常用",
        //     NODEID: null,
        //     IsRoot: true,
        //     isLeaf: true,
        //     state: 0,
        //     pid:'',
        //     children: null
        //   },
        //   {
        //     NODENAME: "团队任务组",
        //     NODEID: '-2',
        //     IsRoot: true,
        //     state: 3,
        //     pid:'',
        //     PermissionType:2,
        //     children: item.children
        //   }];
        console.log('teamTreeData', state.teamTreeData);
      });
    },
  }
});
